module.exports = __webpack_public_path__ + "static/media/MentorMe.d74895ad.PNG";